import reducerRegistry from './../../helpers/ReducerRegistry';
import TimeAndSaleService from '../../../core/services/Prices/TimeAndSale/TimeAndSaleService';
import priceDataService from './../../../core/services/Prices/PriceData/PriceDataService';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'QUOTE_MOVEMENT:';
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_DATA_QUOTE_MOVEMENT = `${REDUCER_NAME}FETCH_DATA_QUOTE_MOVEMENT`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const GET_TOP_CONTENT = `${REDUCER_NAME}GET_TOP_CONTENT`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const RESET_REALTIME_DATA = `${REDUCER_NAME}RESET_REALTIME_DATA`;
const SET_FETCHING = `${REDUCER_NAME}SET_FETCHING`;

export {
  REDUCER_NAME,
  reducer as default,
  fetchDataQuoteMovement,
  changeCode,
  fetchInfoTicker,
  subscribeRealtimeTick,
};

function setFetching(status = true, id) {
  return {
    type: SET_FETCHING,
    payload: {
      status,
      id,
    },
  };
}

function subscribeRealtimeTick(data, id) {
  return (dispatch, getState) => {
    const code = getState()[REDUCER_NAME].listMultiComponent[id].condition.code;

    const result = data.find(bidAsk => bidAsk.organCode === code);
    dispatch({
      type: SUBSCRIBE_REALTIME_DATA_TICK,
      payload: {
        result,
        id,
        testCode: code,
      },
    });
  };
}

function fetchInfoTicker(id, defaultCode = '') {
  return (dispatch, getState) => {
    const code =
      defaultCode ||
      getState()[REDUCER_NAME].listMultiComponent[id].condition.code;
    priceDataService.getLatestPrice({ Code: code }).then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_TOP_CONTENT,
        payload: {
          topContent: items && items.length ? items[0] : {},
          id,
        },
      });
    });
  };
}

function changeCode(data, id, isFetchData = true) {
  return dispatch => {
    dispatch({
      type: CHANGE_CODE,
      payload: {
        currentSearch: data,
        id,
      },
    });
    if (isFetchData) {
      dispatch(fetchDataQuoteMovement({ Code: data.code }, id));
      dispatch(fetchInfoTicker(id));
      dispatch({
        type: RESET_REALTIME_DATA,
        payload: {
          id,
        },
      });
    }
  };
}

function fetchDataQuoteMovement(params, id) {
  const formatParams = formatedParams(params);
  return dispatch => {
    dispatch(setFetching(true, id));
    TimeAndSaleService.getTimeAndSale(formatParams).then(response => {
      const { items = [] } = response;
      dispatch({
        type: FETCH_DATA_QUOTE_MOVEMENT,
        payload: {
          quoteMovementData: items && items.length ? items[0] : {},
          id,
        },
      });
      dispatch(setFetching(false, id));
    });
  };
}

function formatedParams(params) {
  const { Code } = params;
  return {
    Code: Code || 'AAA',
  };
}

const initialState = {
  listMultiComponent: {},
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const dataId = action.payload.id;

      const condition = currentState.get(
        ConstCommon.listComponent.QuoteMovement,
        'condition',
        dataId,
      );

      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            quoteMovementData: {},
            condition: condition || {
              displayCode: 'AAA',
              code: 'AAA',
              isDerivatives: false,
            },
            topContent: {},
            topContentRealTime: {},
            isFetching: false,
          },
        },
      };

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case FETCH_DATA_QUOTE_MOVEMENT:
      const { quoteMovementData, id } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [id]: { ...state.listMultiComponent[id], quoteMovementData },
        },
      };

    case CHANGE_SIZE_COMPONENT: {
      const { id: componentId } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            component: action.payload,
          },
        },
      };
    }

    case CHANGE_CODE: {
      const { id: componentId, currentSearch } = action.payload;

      const { isDerivatives, code, displayCode } = currentSearch;

      currentState.add(
        ConstCommon.listComponent.QuoteMovement,
        'condition',
        { isDerivatives, code, displayCode },
        componentId,
      );
      const listMultiComponent = {
        ...state.listMultiComponent,
        [componentId]: {
          ...state.listMultiComponent[componentId],
          condition: {
            ...state.listMultiComponent[componentId].condition,
            ...currentSearch,
            isDerivatives: !!currentSearch.derivativeCode,
          },
        },
      };
      return {
        ...state,
        listMultiComponent,
      };
    }

    case GET_TOP_CONTENT:
      const {
        topContent: { bidAskInfo, priceInfo },
        id: compoId,
      } = action.payload;
      // const {Best1Bid, Best1Offer} = BidAskInfo
      const Best1Bid = bidAskInfo ? bidAskInfo.best1Bid : null;
      const Best1Offer = bidAskInfo ? bidAskInfo.best1Offer : null;
      const Best1BidVolume = bidAskInfo ? bidAskInfo.best1BidVolume : null;
      const Best1OfferVolume = bidAskInfo ? bidAskInfo.best1OfferVolume : null;

      // const {OpenPrice, HighestPrice, LowestPrice, MatchPrice, PriceChange, PercentPriceChange, ReferencePrice} = PriceInfo
      const OpenPrice = priceInfo ? priceInfo.openPrice : null;
      const HighestPrice = priceInfo ? priceInfo.highestPrice : null;
      const LowestPrice = priceInfo ? priceInfo.lowestPrice : null;
      const MatchPrice = priceInfo ? priceInfo.matchPrice : null;
      const PriceChange = priceInfo ? priceInfo.priceChange : null;
      const PercentPriceChange = priceInfo
        ? priceInfo.percentPriceChange
        : null;
      const ReferencePrice = priceInfo ? priceInfo.referencePrice : null;
      const CeilingPrice = priceInfo ? priceInfo.ceilingPrice : null;
      const FloorPrice = priceInfo ? priceInfo.floorPrice : null;

      const topContent = {
        Bid: Best1Bid,
        Ask: Best1Offer,
        Best1BidVolume,
        Best1OfferVolume,
        OpenPrice,
        HighestPrice,
        LowestPrice,
        MatchPrice,
        PriceChange,
        PercentPriceChange,
        ReferencePrice,
        CeilingPrice,
        FloorPrice,
      };

      const cloneListMultiComponent = {
        ...state.listMultiComponent,
        [compoId]: {
          ...state.listMultiComponent[compoId],
          topContent,
        },
      };
      return {
        ...state,
        listMultiComponent: cloneListMultiComponent,
      };

    case SUBSCRIBE_REALTIME_DATA_TICK:
      const { result: resultTick, id: updateTickId } = action.payload;
      if (resultTick) {
        const {
          openPrice: OpenPrice,
          highestPrice: HighestPrice,
          lowestPrice: LowestPrice,
          matchPrice: MatchPrice,
          priceChange: PriceChange,
          percentPriceChange: PercentPriceChange,
          referencePrice: ReferencePrice,
          tradingDate: TradingDate,
          best1Bid: Best1Bid,
          best1Offer: Best1Offer,
          ceilingPrice: CeilingPrice,
          floorPrice: FloorPrice,
        } = resultTick;

        const topContentRealTime = {
          OpenPrice,
          HighestPrice,
          LowestPrice,
          MatchPrice,
          PriceChange,
          PercentPriceChange,
          ReferencePrice,
          Bid: Best1Bid,
          Ask: Best1Offer,
          TradingDate,
          CeilingPrice,
          FloorPrice,
        };
        const updateRealtimeTick = {
          ...state.listMultiComponent,
          [updateTickId]: {
            ...state.listMultiComponent[updateTickId],
            topContentRealTime,
            quoteMovementData: {
              ...state.listMultiComponent[updateTickId].quoteMovementData,
              matches: [
                ...[resultTick],
                ...state.listMultiComponent[updateTickId].quoteMovementData
                  .matches,
              ],
            },
          },
        };

        return {
          ...state,
          listMultiComponent: updateRealtimeTick,
        };
      }

      return {
        ...state,
      };

    case RESET_REALTIME_DATA:
      const resetId = action.payload.id;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [resetId]: {
            ...state.listMultiComponent[resetId],
            topContentRealTime: {},
          },
        },
      };

    case SET_FETCHING:
      const { id: fetchingId, status } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [fetchingId]: {
            ...state.listMultiComponent[fetchingId],
            isFetching: status,
          },
        },
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
